// extracted by mini-css-extract-plugin
export default {"active":"mapfeatures_active__MDgBg","inactive":"mapfeatures_inactive__agAgy"};